<template>
  <div>
    {{ formatter() }}
  </div>
</template>
<script>
import Formatter from 'src/class/Formatter';

export default {
  name: 'price-format',
  props: {
    format: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
  },
  methods: {
    formatter() {
      const prev = this.format === '$' ? this.format : '';
      const after = this.format === '%' ? this.format : '';

      return `${prev}${Formatter.formatNumber(Number(this.value))}${after}`;
    },
  },
};
</script>
